import { render, staticRenderFns } from "./CampaignFieldRow.vue?vue&type=template&id=10dcd5d6&lang=pug"
import script from "./CampaignFieldRow.vue?vue&type=script&lang=js"
export * from "./CampaignFieldRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports